import type { ClientMenuItem } from '@dealerportal/common';
import classNames from 'classnames';
import { useContext } from 'react';
import NavDesktopMenuItems from './NavDesktopMenuItems';
import { NavigationContext } from './Navigation';

export function NavDesktopMenuDropdown({
  submenus,
  dropdown,
  depthLevel,
  className,
}: {
  submenus: ClientMenuItem[];
  dropdown: boolean;
  depthLevel: number;
  className?: string;
}) {
  const navClassNames = useContext(NavigationContext);

  const adjustedDepthLevel = depthLevel + 1;
  const dropdownClass =
    adjustedDepthLevel > 1
      ? 'ui-absolute ui-left-full ui-top-0'
      : 'ui-top-full';

  return (
    <ul
      className={classNames(
        `${
          depthLevel === 0 ? 'nav__child-list' : 'nav__grandchild-list'
        } dropdown sm:ui-absolute sm:ui-min-w-[216px] ui-left-0 ui-w-min !ui-m-0 ui-z-50 ui-text-sm !ui-list-none ui-bg-white ui-shadow-lg ${
          navClassNames.childlistclass
        }`,
        { last: adjustedDepthLevel === 1 },
        { '!ui-block': dropdown },
        { 'ui-hidden': !dropdown },
        `${dropdownClass}`,
        `${className}_submenu`
      )}
    >
      {submenus.map((submenu, index) => (
        <NavDesktopMenuItems
          key={`${submenu.alias}-${index}`}
          items={submenu}
          depthLevel={adjustedDepthLevel}
          className={className}
        />
      ))}
    </ul>
  );
}
export default NavDesktopMenuDropdown;
